export default function dateFilter(value) {
  const date = new Date(value)
  let options = {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
  }
  return date.toLocaleDateString('pl-PL', options)
}
